import { useEffect, useRef, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import config, { RemoveSession, SetSession } from '../../EnvConfig/env_config';
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
export default function SignIn() {
    const inputrefs = useRef([]);
    const StaticToken = config.secret_key;
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false)
    const [user, setUser] = useState({ userCode: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const handleLogin = async () => {
        setIsLoading(true);
        const data = {
            ...user,
            AuthToken: StaticToken,
            LoginUserCode: '',
            Source: 'web'
        }
        let res = await ApiCall(`/api/UserLogin/Login`, data)
        if (res.status === 'SUCCESS') {
            SetSession('cookies', 'token', res.token);
            SetSession('localStorage', 'theme', 'light');
            SetSession('cookies', 'loginUserCode', res.loginUserCode);
            SetSession('cookies', 'userName', res.userName);
            SetSession('cookies', 'branchCode', res.loginBCode);
            SetSession('cookies', 'user', res)
            setTimeout(() => {
                setIsLoading(false);
                navigate(location.state || '/dashboard')
                localStorage.setItem('ID', "10040")
            }, 700)
        } else {
            setIsLoading(false);
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    };

    const SendEmail = async () => {
        setIsLoading(true);
        const data = {
            UserCode: user.userCode,
           /* Source: 'web'*/
        }
        let res = await ApiCall(`/api/UserLogin/ForgetPassword`, data)
        if (res.status === 'SUCCESS') {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
            setIsLoading(false);
        }
        if (res.status === 'ERROR') {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
            setIsLoading(false);
        }
    };

    const handleTogglePassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };
    useEffect(() => {
        inputrefs.current['txtUserCode'].focus()
        RemoveSession('cookies', 'token')
        RemoveSession('cookies', 'loginUserCode')
        RemoveSession('cookies', 'userName')
        RemoveSession('cookies', 'user')
        RemoveSession('cookies', 'branchCode')
    }, [])

    return (
        <>
            <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center" >
                <div className="row" data-aos="zoom-in" data-aos-duration="1000" >
                    <div className="col-sm-3 px-4 py-5 main-login text-black rounded">
                        <div className=''>
                            <img src="./assets/img/mainlogo.png" className='img1' alt="..." style={{ display: "flex" }} />
                        </div>
                        <div className="innerlogindiv ">
                            <h5 className="mb-4 mt-2 text-center" style={{ textShadow: '2px 2px 2px #c7ad79' }}> Welcome To
                                <br /><span className='fw-bold ' style={{ color: "var(--mycolorFilterCheckText)", textShadow: '1px 1px 1px white' }} > Grand Slam Express</span>
                            </h5>

                            <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                <div className="fields">
                                    <label className="form-label" style={{ color: '#74531f', fontSize: '14px' }}>User Code</label>
                                    <input
                                        id="txtUserCode"
                                        ref={ref => (inputrefs.current['txtUserCode'] = ref)}
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        name='userCode'
                                        placeholder='User Code'
                                        maxLength='50'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtPassword'].focus()
                                            };
                                        }}
                                        value={user.userCode}
                                        onChange={(e) => {
                                            setUser({ ...user, userCode: e.target.value })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%', position: "relative", }}>
                                <div className="fields">
                                    <label className="form-label" style={{ color: '#74531f', fontSize: '14px' }}>Password</label>
                                    <input
                                        id="txtPassword"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleLogin(e)
                                            };
                                        }}
                                        type={showPassword ? 'text' : 'password'}
                                        ref={ref => (inputrefs.current['txtPassword'] = ref)}
                                        className="form-control"
                                        autoComplete="off"
                                        placeholder='Password'
                                        maxLength='20'
                                        name='Password'
                                        value={user.password}
                                        onChange={(e) => setUser({ ...user, password: e.target.value })}
                                    />
                                </div>
                                <span style={{ position: "absolute", cursor: "pointer", left: "92%", bottom: "7%" }} onClick={handleTogglePassword}>
                                    {showPassword ? <FaEyeSlash style={{ color: "#CC9966" }} /> : <FaEye style={{ color: "#CC9966" }} />}
                                </span>
                            </div>
                            <div className="py-2 loading">
                                <button className='btn  w-100 login-btn loginhover' onClick={handleLogin} >Login</button>
                                {isLoading && (<BlurLoader />)}
                            </div>

                            <Link style={{ fontSize: "14px" }}
                                onClick={SendEmail}
                                onMouseEnter={(e) => e.target.style.color = '#CC9966'}
                                onMouseLeave={(e) => e.target.style.color = 'blue'} 
                                
                            >
                                forgot password?
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}





